module.exports = __webpack_public_path__ + "img/3-medal.95cd196c.webp";